import { useQuery } from "@tanstack/react-query";
import { getGanttData } from "../../../repositories/ProductionRepository";
import type { Process, ProcessEvent } from "../../../models/ProcessGanttChart";

interface GanttQueryData {
  processes: Process[];
  processEvents: ProcessEvent[];
}

export const useDashboardGanttQuery = (
  startDate: Date | null,
  endDate: Date | null,
) => {
  return useQuery({
    queryKey: [
      "dashboard-gantt",
      startDate?.toISOString(),
      endDate?.toISOString(),
    ],
    queryFn: async ({ signal }) => {
      const resp = await getGanttData(startDate, endDate, signal);
      if (resp.ok) {
        return {
          processes: resp.data?.tables[0].rows ?? [],
          processEvents: resp.data?.tables[1].rows ?? [],
        } as GanttQueryData;
      }
      throw new Error(resp.message ?? "Failed to fetch gantt data");
    },
    enabled: !!startDate && !!endDate,
  });
};
